<template>
  <div v-loading="dataLoading">
    <div v-if="currentMenu !== 0 && info.merchantName" class="current-merchant">{{$t('message.user.curApplyMerchant', { merchant: info.merchantName })}}</div>
    <!-- 错误信息 -->
    <div v-if="errorMessage" class="fail-reason-box" :class="{'expand': showErrorDetails}" @click="handleErrorReason">
      <p>{{$t('message.collection.errorTitle')}}</p>
      <p v-show="showErrorDetails">{{errorMessage}}</p>
      <i class="el-icon-arrow el-icon-arrow-up" :class="{'is-reverse': showErrorDetails}"></i>
    </div>
    <div class="supplement-business">
      <div class="supplement-business-menu">
        <div
          v-for="(item, index) in menuList"
          :key="index"
          class="business-menu-item"
          :class="[currentMenu === item.value ? 'active' : '']"
          @click="handleMenuClick(item.value)">
          {{item.label}}
        </div>
      </div>
      <template v-if="currentMenu === 0">
        <BusinessInfo ref="info0" :info="info" @finish="handleNext"></BusinessInfo>
      </template>
      <template v-else-if="currentMenu === 1">
        <LegalInfo ref="info1" :info="info" @finish="handleNext" @refresh="onRefresh"></LegalInfo>
      </template>
      <template v-else-if="currentMenu === 2">
        <ShareholderInfo ref="info2" :info="info" @finish="handleNext"></ShareholderInfo>
      </template>
      <template v-else-if="currentMenu === 3">
        <AddressInfo ref="info3" :info="info" @finish="handleNext"></AddressInfo>
      </template>
    </div>
  </div>
</template>

<script>
import { improveInformation, updateInformation, quickRegistrationInfo } from '@/api/common/user';
import { ShowWarningMessage } from '@/components/modal/tips/message-tips';
import { setLocalStorage, shallowClones } from '@/utils/tools/utils';
import AddressInfo from '@/views/account/information/supplement/business/address-info.vue';
import BusinessInfo from '@/views/account/information/supplement/business/business-info.vue';
import LegalInfo from '@/views/account/information/supplement/business/legal-info.vue';
import ShareholderInfo from '@/views/account/information/supplement/business/shareholder-info.vue';

export default {
  components: {
    BusinessInfo,
    LegalInfo,
    ShareholderInfo,
    AddressInfo,
  },
  props: {
    quickRegistration: {
      type: Boolean,
      default: false,
    },
    merchantNo: {
      type: String,
      default: '',
    },
    serviceType: {
      type: String,
      default: '',
    },
    supplementInfo: {
      type: Object,
      default: () => ({}),
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dataLoading: false,
      currentMenu: 0,
      menuList: [{
        label: this.$t('message.user.companyInformation'),
        value: 0,
      }, {
        label: this.$t('message.user.legalInformation'),
        value: 1,
      }, {
        label: this.$t('message.user.shareholderInfo'),
        value: 2,
      }, {
        label: this.$t('message.user.contactAddress'),
        value: 3,
      }],
      info: {
        type: 1, // 企业类型，1：企业  2：个人
      },
      showErrorDetails: false,
    };
  },
  created() {
    this.info.businessType = this.serviceType;
    this.initMethod();
  },
  methods: {
    initMethod() {
      if (this.supplementInfo && `${this.supplementInfo.type}` === '1') { // 存在初始数据
        this.info = shallowClones(this.supplementInfo);
      }
    },
    async handleMenuClick(value) {
      try {
        const check = this.currentMenu === 0; // 切换时是否校验当前数据，目前只在第一步做校验
        const data = await this.$refs[`info${this.currentMenu}`].submit(check);
        Object.assign(this.info, data);
        this.currentMenu = (+value);
      } catch (err) {
      }
    },
    onSubmit() {
      this.$emit('finish');
    },
    validateLegal() {
      if (!this.info.name || !this.info.idNumber || !this.info.businessLicense ||
        !this.info.effectiveDate || !this.info.expireDate ||
        !this.info.blEffectiveDate || !this.info.blExpireDate || (!this.info.materialList || !this.info.materialList.length)) {
        return false;
      }
      for (let i = 0; i < this.info.materialList.length; i++) {
        const material = this.info.materialList[i];
        if (material.required && !material.fileUrl) {
          return false;
        }
      }
      return true;
    },
    validate() {
      const info1Valid = this.validateLegal();
      if (!info1Valid) {
        ShowWarningMessage(this.$t('message.user.pleaseCompleteLegalInformation'));
        this.currentMenu = 1;
        return false;
      }
      return true;
    },
    getFormData() {
      const data = {
        type: this.info.type,
        businessType: this.info.businessType,
        registration: this.info.registration,
        merchantName: this.info.merchantName,
        name: this.info.name,
        idNumber: this.info.idNumber,
        effectiveDate: this.info.effectiveDate,
        expireDate: this.info.expireDate,
        businessLicense: this.info.businessLicense,
        blEffectiveDate: this.info.blEffectiveDate,
        blExpireDate: this.info.blExpireDate,
        country: this.info.country,
        province: this.info.province,
        city: this.info.city,
        address: this.info.address,
        materialList: this.info.materialList,
        shareholderInfoList: this.info.shareholderInfoList,
        quickRegistration: this.quickRegistration,
      };
      if (`${this.info.businessType}` === '0') { // 付款商户特有字段
        data.merchantNameEn = this.info.merchantNameEn;
        data.registerDate = this.info.registerDate;
        data.addressEn = this.info.addressEn;
      }
      return data;
    },
    async handleNext(data = {}) {
      if (this.currentMenu === 0 && (this.info.registration !== data.registration)) { // 修改企业注册地时，需要清空材料模板
        this.info.materialList = [];
      }
      Object.assign(this.info, data);
      if (this.currentMenu === 3) { // 则提交保存数据
        const valid = this.validate();
        if (!valid) {
          return;
        }
        const params = this.getFormData();
        this.dataLoading = true;
        try {
          let MethodSub = this.merchantNo ? updateInformation : improveInformation;
          if (this.quickRegistration) { // 快速注册
            MethodSub = quickRegistrationInfo;
          }
          const res = await MethodSub(params);
          if (!this.merchantNo && !this.quickRegistration) { // 新增时(除快捷注册外)修改缓存
            setLocalStorage('userLogin', JSON.stringify(res));
          }
          this.onSubmit();
        } catch (err) {
        }
        this.dataLoading = false;
        return;
      }
      this.currentMenu += 1;
    },
    onRefresh(data = {}) {
      Object.assign(this.info, data);
    },
    handleErrorReason() {
      this.showErrorDetails = !this.showErrorDetails;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/element-variables.scss';
.current-merchant {
  width: 450px;
  height: 30px;
  background: $color-default;
  padding: 0 10px;
  font-size: 14px;
  font-weight: 400;
  color: $color-text-primary;
  line-height: 30px;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.fail-reason-box {
  position: relative;
  width: 450px;
  height: 30px;
  background: #FFF2F2;
  margin: 0 auto;
  margin-top: 10px;
  cursor: pointer;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: $color-text-primary;
  line-height: 32px;
  padding-left: 10px;
  padding-right: 30px;
  box-sizing: border-box;
  white-space: pre-line;

  &.expand {
    height: auto;
    padding-bottom: 10px;

    .el-icon-arrow {
      transform: rotateX(180deg);
    }
  }

  .el-icon-arrow {
    position: absolute;
    right: 10px;
    top: 10px;
    transition: all 0.2s;
  }
}

.supplement-business {
  position: relative;
  margin-bottom: 100px;
  margin-top: 20px;

  .supplement-business-menu {
    position: absolute;
    width: 140px;
    min-height: 225px;
    background: $color-default;
    left: -180px;
    box-sizing: border-box;

    .business-menu-item {
      padding-left: 20px;
      margin-top: 10px;
      font-size: 14px;
      font-weight: 600;
      color: $color-text-primary;
      line-height: 32px;
      cursor: pointer;

      &.active {
        color: $color-primary;
      }
    }
  }
}
</style>
<style lang="scss">
html[lang=en] .fail-reason-box {
  width: 520px !important;
}
</style>
